var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCircleCheck = function SvgCircleCheck(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12",
    fill: "currentColor",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 12C2.69531 12 0 9.30469 0 6C0 2.69531 2.69531 0 6 0C9.30469 0 12 2.69531 12 6C12 9.30469 9.30469 12 6 12ZM8.76562 3.42188C8.50781 3.23438 8.15625 3.28125 7.99219 3.53906L5.17969 7.38281L3.96094 6.16406C3.75 5.95312 3.375 5.95312 3.16406 6.16406C2.95312 6.39844 2.95312 6.75 3.16406 6.96094L4.85156 8.64844C4.96875 8.76562 5.13281 8.83594 5.29688 8.8125C5.46094 8.8125 5.60156 8.71875 5.69531 8.57812L8.88281 4.19531C9.07031 3.96094 9.02344 3.60938 8.76562 3.42188Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCircleCheck);
export default ForwardRef;